import axios from 'axios'
import { Message } from 'element-plus'
// import Vue from 'vue'

const baseUrl = require('../../../devServer.config').baseUrl
window.axios.defaults.baseURL = baseUrl

const type = process.env.NODE_ENV === 'd ' +
'evelopment' ? 'application/x-www-form-urlencoded; charset=utf-8' : 'application/json; charset=utf-8' // eslint-disable-line
// 创建axios实例
const service = axios.create({
  baseURL: window.axios.defaults.baseURL, // api的base_url
  headers: {
    Accept: 'application/json',
    // 'Content-Type': type // 前端人员链接yapi服务mock数据时将其改为'Content-Type': type  、
    'Content-Type': 'application/json; charset=utf-8',
    'Authorization': decodeURIComponent(location.search).substr(1)
  }
})

const fetch = axios.create({
  headers: {
    Accept: 'application/json',
    // 这里必须使用application/json，不然bodyparser 处理参数会将boolean类型与number类型处理成string
    'Content-Type': 'application/json; charset=utf-8'
  }
})

// request拦截器
service.interceptors.request.use(
  config => {
  if (config.isMock) {
    config.baseURL = 'http://39.98.200.240:9090/mock/164'
  }
  if (config.flag) { // 后端接口以formdata接收参数
    config.headers = {
      Accept: 'application/json, text/javascript, */*; q=0.01',
      'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
    }
    config.data = qs.stringify(config.data)
  }
  if (!config.data) {
    config.data = {}
  }
  return config
}, error => {
  Message.error({
    showClose: true,
    message: '加载超时',
    type: 'error'
  })
  console.log(error) // for debug
  Promise.reject(error)
})

// respone拦截器
service.interceptors.response.use(
  response => {
    if (response) {
      const data = response.data
      console.log('fetch', data)
      if (data.sessionOut) {
        Message.error({
          showClose: true,
          message: '页面超时',
          type: 'error'
        })
        setTimeout(_ => {
          window.location.href = '/login'
        }, 1000)
      } else {
        return data
      }
    } else {
      return null
    }
  },
  error => {
    if (error.response && error.response.status === 401) {
      window.location.href = '/login'
    }
    console.error('Error', error)
    return error
  }
)

export default service
